
import React, { useState, useEffect, useCallback } from 'react';
import { useNotification } from '../context/NotificationContext';
import './UserFormModal.css'; // Assuming it shares styles

function HotelFormModal({ isOpen, onClose, onHotelSaved, editingHotel }) {
    const [name, setName] = useState('');
    const [totalRooms, setTotalRooms] = useState('');
    const [type, setType] = useState('Propio');
    const [city, setCity] = useState('');
    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const { showNotification } = useNotification();

    useEffect(() => {
        if (editingHotel) {
            setName(editingHotel.name);
            setTotalRooms(editingHotel.total_rooms_available);
            setType(editingHotel.type || 'Propio');
            setCity(editingHotel.city || '');
        } else {
            setName('');
            setTotalRooms('');
            setType('Propio');
            setCity('');
        }
    }, [editingHotel, isOpen]);

    const getAuthHeader = useCallback(() => {
        const token = localStorage.getItem('token');
        return token ? { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' } : {};
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const rooms = parseInt(totalRooms, 10);
        if (!name || !type || !city || !rooms || rooms <= 0) {
            setError('Nombre, Ciudad, Tipo y un número válido de cuartos son obligatorios.');
            return;
        }
        setIsSubmitting(true);
        setError('');

        const isEditMode = !!editingHotel;
        
        // --- THIS IS THE FIX ---
        // Build the URL using the environment variable
        const path = isEditMode ? `hotels/${editingHotel.hotel_id}` : 'hotels';
        const url = `${process.env.REACT_APP_API_URL}/api.php?path=${path}`;
        
        const method = isEditMode ? 'PUT' : 'POST';

        const body = { 
            name, 
            city,
            type,
            total_rooms_available: rooms 
        };

        try {
            const response = await fetch(url, {
                method: method,
                headers: getAuthHeader(),
                body: JSON.stringify(body)
            });

            const result = await response.json();
            
            // Correctly handle the standard API response for success and error
            if (response.ok && result.success) {
                showNotification(result.data.message || (isEditMode ? 'Hotel actualizado!' : 'Hotel creado!'), 'success');
                onHotelSaved();
                onClose();
            } else {
                throw new Error(result.error?.message || 'Ocurrió un error desconocido.');
            }
            
        } catch (err) {
            console.error("Error saving hotel:", err);
            setError(err.message);
            showNotification(err.message, 'error');
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!isOpen) { return null; }

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <h2>{editingHotel ? 'Editar Hotel' : 'Agregar Nuevo Hotel'}</h2>
                    <button onClick={onClose} className="close-button">&times;</button>
                </div>
                <div className="modal-body">
                    <form onSubmit={handleSubmit}>
                        {error && <p className="error-message">{error}</p>}
                        <div className="form-group">
                            <label htmlFor="hotel-name">Nombre del Hotel</label>
                            <input type="text" id="hotel-name" value={name} onChange={(e) => setName(e.target.value)} required />
                        </div>
                        
                        <div className="form-group">
                            <label htmlFor="hotel-city">Ciudad</label>
                            <input type="text" id="hotel-city" value={city} onChange={(e) => setCity(e.target.value)} required />
                        </div>

                        <div className="form-group">
                            <label htmlFor="hotel-type">Tipo</label>
                            <select id="hotel-type" value={type} onChange={(e) => setType(e.target.value)}>
                                <option value="Propio">Propio</option>
                                <option value="Competencia">Competencia</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label htmlFor="total-rooms">Total de Cuartos</label>
                            <input type="number" id="total-rooms" value={totalRooms} onChange={(e) => setTotalRooms(e.target.value)} required />
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="cancel-btn" onClick={onClose} disabled={isSubmitting}>Cancelar</button>
                            <button type="submit" className="submit-btn" disabled={isSubmitting}>
                                {isSubmitting ? 'Guardando...' : 'Guardar Hotel'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default HotelFormModal;